var map = {
	"./black/xiugaiyinliang2.png": "kzzY",
	"./blue/xiugaiyinliang2.png": "aeKS",
	"./white/xiugaiyinliang2.png": "+L2H"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sDnt";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/xiugaiyinliang2\.png$
// module id = sDnt
// module chunks = 24